// extracted by mini-css-extract-plugin
export default {"wrapper":"TTd6Q95nEIwx20_74Sop","disableResize":"Hf0yF1EYwV1NF7XXV9pd","disabled":"q6bVvPjSf4heJNHc1_m2"};